import {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

// A single shared video panel: a story's video opens in a panel that slides
// up from the bottom of the screen, covering most of it. Only one video
// plays at a time.

export const VideoPlayerContext = createContext(null);

export function VideoPlayerProvider({ children }) {
  const [current, setCurrent] = useState(null);

  const play = useCallback((story) => {
    setCurrent(story);
  }, []);

  const stop = useCallback(() => {
    setCurrent(null);
  }, []);

  const value = { current, play, stop };

  return (
    <VideoPlayerContext.Provider value={value}>
      {children}
    </VideoPlayerContext.Provider>
  );
}

export function useVideoPlayer() {
  const context = useContext(VideoPlayerContext);
  if (context === null) {
    throw new Error('useVideoPlayer must be used within a VideoPlayerProvider');
  }
  return context;
}